export default "__VITE_ASSET__93545bdd__"